export default __webpack_public_path__ + "static/B0018-e4b64fadae9078ede6eb9eed61398938.png";